<template>
  <v-app :dark="dark" id="app">
    <beez-sidebar v-model="drawer" />

    <beez-toolbar
      @themeChange="changeTheme"
      v-on:toggleDrawer="drawer = !drawer"
    />

    <v-content>
      <v-flex fill-height class="pa-2">
        <v-layout justify-center column fill-height>
          <v-flex xs12 fill-height>
            <!-- This is where sub views will be mounted -->
            <transition name="fade" mode="out-in">
              <router-view @themeChange="changeTheme" />
            </transition>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-content>
    <!--    <v-btn-->
    <!--      fab-->
    <!--      v-show="scrollShow"-->
    <!--      fixed-->
    <!--      bottom-->
    <!--      right-->
    <!--      color="primary"-->
    <!--      @click="toTop"-->
    <!--    >-->
    <!--      <v-icon>keyboard_arrow_up</v-icon>-->
    <!--    </v-btn>-->
    <beez-footer />
    <div class="vld-parent">
      <loading :active.sync="honeyLoader" loader="dots"></loading>
    </div>
  </v-app>
</template>

<script>
import Sidebar from './TheSidebar'
import Toolbar from './TheToolbar'
import Footer from './TheFooter'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  data: () => ({
    dialog: false,
    scrollShow: null,
    drawer: true,
    dark: false,
    honeyLoader: false
  }),
  computed: {
    ...mapState({
      user: state => state.session.user,
      userSettings: state => state.honeyUsers.userSettings,
      colors: state => state.theme.themes
    })
  },

  async created() {
    this.honeyLoader = true
    this.initLists()
    await this.$store.dispatch('initHoneyTheme')
    await this.$store.dispatch('fetchUserSettings')
    await this.$store.dispatch('getUserPrincipal')
    this.changeTheme(this.userSettings.isDark)
    let selectedColor = this.colors[this.userSettings.theme]
    if (!this.userSettings.isDark) {
      this.$vuetify.theme.primary = selectedColor.theme.light.primary
      this.$vuetify.theme.secondary = selectedColor.theme.light.secondary
      this.$vuetify.theme.accent = selectedColor.theme.light.accent
    } else {
      this.$vuetify.theme.primary = selectedColor.theme.dark.primary
      this.$vuetify.theme.secondary = selectedColor.theme.dark.secondary
      this.$vuetify.theme.accent = selectedColor.theme.dark.accent
    }
    this.honeyLoader = false
  },
  methods: {
    changeTheme(theme) {
      this.dark = theme
    },
    async initLists() {
      // this.$store.dispatch('fetchSelfServices')
      // this.$store.dispatch('fetchWorkflows')
      // this.$store.dispatch('fetchBots')
      // this.$store.dispatch('fetchBotTemplates')
      // this.$store.dispatch('fetchHives')
      // this.$store.dispatch('fetchRules')
      // this.$store.dispatch('fetchIdentities')
      this.$store.dispatch('fetchIdentityTypes')
      // this.$store.dispatch('fetchHoneyForms')
      // this.$store.dispatch('fetchEmailTemplates')
      this.$store.dispatch('fetchHiveTypes')
      this.$store.dispatch('fetchHiveConnectionTypes')
      this.$store.dispatch('fetchRunStatuses')
      this.$store.dispatch('fetchHiveConnectionStructures')
      this.$store.dispatch('fetchIdentityStructure')
      // this.$store.dispatch('fetchHoneyUsers')
      if (
        this.user.roles &&
        this.user.roles.length > 0 &&
        this.user.roles.indexOf('SUPPORT') > -1
      ) {
        this.$store.dispatch('getTulipUnderMaintenance').catch(() => {})
      }
      if (
        this.user.roles &&
        this.user.roles.length > 0 &&
        this.user.roles.indexOf('AUTOMATION_ADMIN') > -1
      ) {
        this.$store.dispatch('getBlockedSupport').catch(() => {})
      }
    }
    // onScroll(e) {
    //   if (typeof window === 'undefined') return
    //   const top = window.pageYOffset || e.target.scrollTop || 0
    //   this.scrollShow = top > 20
    // },
    // toTop() {
    //   this.$vuetify.goTo(0)
    // }
  },
  props: {
    source: String
  },

  components: {
    BeezSidebar: Sidebar,
    BeezToolbar: Toolbar,
    BeezFooter: Footer,
    Loading
  }
}
</script>
